/*
 * Which maternity hospital an MN-CMS message is actually going to (KIN-2031).
 *
 * Not the consultant's hospital — the pregnancy's own receiving facility, which the backend puts
 * in MSH.6. The two are routinely different, and the send prompt never named either, so a
 * pregnancy set up against the wrong facility was only discovered after the message had gone.
 *
 * The lookup is the same one the backend builds MSH.6 from, matched on healthlinkId, so the
 * screen and the message cannot disagree.
 */

export const RECEIVING_HOSPITAL_MISSING_FIELD =
  "Receiving maternity hospital (edit pregnancy)";

// Used only until the hospital list has loaded. A send is gated on the code being present, so
// this never stands in for a pregnancy that has no destination.
export const UNNAMED_DESTINATION = "the Maternity Hospital";

export const resolveReceivingHospitalName = (pregnancy, hospitals) => {
  const code = pregnancy?.receivingFacilityCode;

  if (!code) return null;

  const match = (hospitals ?? []).find(
    (hospital) => String(hospital.value) === String(code)
  );

  /*
   * A code with no entry in the list still names something the GP can act on, and the backend
   * falls back the same way — HD.1 is the bare code when it cannot resolve a name.
   */
  return match?.label ?? `hospital ${code}`;
};

export const describeMncmsDestination = (pregnancy, hospitals) =>
  resolveReceivingHospitalName(pregnancy, hospitals) ?? UNNAMED_DESTINATION;
